import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid p-0 m-0 justify-content-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "mr-2" }, "Senha da Assinatura:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pm_InputText = _resolveComponent("pm-InputText")!
  const _component_pm_Button = _resolveComponent("pm-Button")!
  const _component_pm_Dialog = _resolveComponent("pm-Dialog")!

  return (_openBlock(), _createBlock(_component_pm_Dialog, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
    modal: "",
    header: "Assinar",
    style: { width: '20vw' }
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_pm_Button, {
        label: "Assinar",
        icon: "pi pi-times",
        onClick: _ctx.validar,
        text: ""
      }, null, 8, ["onClick"]),
      _createVNode(_component_pm_Button, {
        label: "Assinar e Enviar",
        icon: "pi pi-check",
        autofocus: "",
        onClick: _ctx.validar
      }, null, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.senhaAssinador) + " ", 1),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_pm_InputText, {
          type: "password",
          class: _normalizeClass({ 'p-invalid': _ctx.errors.senhaAssinador != '' }),
          modelValue: _ctx.senhaAssinador,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.senhaAssinador) = $event)),
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validate('senhaAssinador'))),
          onKeypress: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validate('senhaAssinador')))
        }, null, 8, ["class", "modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}